<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { DynamicForm } from '../../dynamic-form'
import { getForm } from '../../../core/services/forms'
import { getEntityModel } from '../../../core/services/entities'
import { getErrorCode } from '@/app/core/composable/general'
import { DLoading } from 'front-library'
import { useI18n } from 'vue-i18n'
usePayrollChange(() => back())

/* router, notifications */
const router = useRouter()
const route = useRoute()
const notifications = useNotificationsStore()
const customForm = ref<any>({})
const { t } = useI18n()

/* Datos componente Loading */
const loading = ref(false)

/* Datos */
let model: any = {}

const getEntity = async () => {
  loading.value = true
  try {
    if (!route.params.id) return
    model = await getEntityModel(route.params.id as string)
    if (model === undefined) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('entities.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    }
    loading.value = false
  } catch (error: any) {
    if (error.response.status === 400) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('entities.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    } else {
      loading.value = false
      const code = getErrorCode(error.response.data?.code)
      notifications.addNotification({
        title: t('error.titles.' + code),
        text: t('error.messages.' + code),
        type: 'error',
        time: 10000
      })
    }
  }
}

const back = () => {
  void router.push({ name: 'ListEntities' })
}

onBeforeMount(async () => {
  await getEntity()
  customForm.value = await getForm({
    entity: 'entities'
  })
})
</script>
<template>
  <DLoading v-show="loading" :message="$t('loading.data')" />
  <div class="h-full px-5">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow text-blue-900"
          v-html="t('entities.get')" />
      </div>
    </div>
    <DynamicForm
      v-if="customForm?.tabs"
      :form-schema="customForm"
      :initial-model="model"
      :readonly="true"
      :get-data="true"
      @cancel="back" />
  </div>
</template>
